




import { defineComponent } from "@vue/composition-api";
import { PaymentPackage } from "@scrile/api-provider/dist/api/PaymentPackageProvider";
import { SubscriptionLevel } from "@scrile/api-provider/dist/api/SubscriptionLevelProvider";
import { $t } from "@/lib/i18nHelpers";
import { formatMoneyString } from "@/lib/moneyHelpers";
import { FormFields, FormValues } from "@/types";
import BaseForm from "@/components/BaseForm";

export default defineComponent({
  name: "PriceSetupView",
  components: { BaseForm },
  props: {
    priceList: { type: Array as () => SubscriptionLevel[], required: true },
    packageList: { type: Array as () => PaymentPackage[], required: true },
    values: { type: Object as () => FormValues, required: true },
  },
  model: {
    event: "input",
    prop: "values",
  },
  computed: {
    isFree(): boolean {
      return this.values.levelId === "0" && this.values.pricePackageId === "0";
    },
    fields(): FormFields {
      const subscriptionList = [
        { text: this.isFree ? $t("Available for everyone") : $t("Disable access by subscription"), value: "0" },
      ].concat(
        this.priceList.map((price, index) => {
          const prices = formatMoneyString(price.pricePackage?.amount ?? 0);
          return {
            text: index === this.priceList.length - 1 ? prices : $t("{0} and higher", [prices]),
            value: price.id,
          };
        })
      );

      const packageOptions = [{ text: $t("Disable one-time buy"), value: "0" }].concat(
        this.packageList.map(packageData => ({
          text: formatMoneyString(packageData.amount),
          value: packageData.id,
        }))
      );

      return [
        {
          name: "levelId",
          label: $t("For subscribers"),
          type: "select",
          options: subscriptionList,
        },
        {
          name: "pricePackageId",
          label: $t("One-time buy"),
          type: "select",
          options: packageOptions,
        },
      ];
    },
  },
});
